import {$, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {PanelUserType} from '@/model/resource/PanelUserType'
import {TipoCliente as TipoClienteEnum} from '@/enums/TipoCliente'
import {TipoCliente} from '@/model/resource/TipoCliente'
import {UserType} from '@/model/resource/UserType'
import {Administrador} from '@/model/resource/Administrador'

export class PanelUserInfo extends Resource {
  idPanelUserFk: number = 0
  towerControlManagerName: string | null = null
  tmsIntegration: string | null = null
  partnerName: string | null = null
  administrator: Administrador | null = null
  get idPanelUserTypeFk() {
    if (!this.panelUserType) return 0
    return this.panelUserType.$id
  }
  set idPanelUserTypeFk(val) {
    if (!this.panelUserType) this.panelUserType = new PanelUserType()
    this.panelUserType.$id = val
  }

  @ResponseSerialize(PanelUserType)
  panelUserType: PanelUserType | null = null

  get $id() {
    return this.idPanelUserFk
  }
  get $tag() {
    return this.idPanelUserFk.toString()
  }

  set tipoCliente(val: TipoCliente) {
    if (this.panelUserType == null) {
      this.panelUserType = new PanelUserType()
    }
    this.panelUserType.idPanelUserTypePk = val.idTipoClientePk
  }
  get tipoCliente() {
    const cliente = new TipoCliente()
    cliente.idTipoClientePk = this.idPanelUserTypeFk || 1
    cliente.nome =
      cliente.idTipoClientePk == 1
        ? String($.t('schema.PanelUserType.customer'))
        : String($.t('schema.PanelUserType.partner'))
    return cliente
  }

  get idAdministradorFk() {
    if (!this.administrator) {
      this.administrator = new Administrador()
    }
    return this.administrator.idAdministradorPk
  }

  set idAdministradorFk(val: number) {
    if (!this.administrator) {
      this.administrator = new Administrador()
    }
    this.administrator.idAdministradorPk = val
  }
  static buildNew(): PanelUserInfo {
    const info = new PanelUserInfo()
    info.panelUserType = new PanelUserType()
    info.panelUserType.idPanelUserTypePk = TipoClienteEnum.Cliente
    return info
  }
}
